module.exports = __webpack_public_path__ + "static/img/liepin.8863debd.png";